
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import Iconify from "../iconify/Iconify";

export default function OutletTypesMenu({ anchorEl, open, onClose, setIsHoveringMenu }) {
  const items = [
    { label: "Food court", icon: "ph:storefront-bold", path: "/pos/food-court" },
    { label: "Cafe", icon: "ph:coffee-bold", path: "/pos/cafe-shops" },
    { label: "Cloud kitchen", icon: "ph:cloud-bold", path: "/pos/cloud-kitchen" },
    { label: "Ice cream & desserts", icon: "ph:ice-cream-bold", path: "/pos/ice-cream" },
    { label: "Bar & brewery", icon: "ph:beer-stein-bold", path: "/pos/bar-brewery" },
    { label: "Bakery", icon: "ph:cake-bold", path: "/pos/bakery" },
    { label: "Fine dine", icon: "ph:bowl-food-bold", path: "/pos/fine-dine" },
    { label: "QSR", icon: "ph:hamburger-bold", path: "/pos/qsr" },
    { label: "Pizzeria", icon: "ph:pizza-bold", path: "/pos/pizzeria" },
    { label: "Large chain", icon: "ph:storefront-duotone", path: "/pos/large-chain" },
  ];
  const navigate = useNavigate();

  const handleMenuItemClick = (path) => {
    if (path) {
      navigate(path);
      if (onClose) onClose();
    }
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        onMouseEnter: () => setIsHoveringMenu(true),
        onMouseLeave: () => {
          setIsHoveringMenu(false);
          onClose();
        },
        sx: {
          padding: "0",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: "20px",
          width: "500px",
        },
      }}
      PaperProps={{
        elevation: 3,
        sx: {
          mt: 1.2,
          p: "16px 22px",
          borderRadius: "14px",
        },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
    >
      {items.map((item, index) => (
        <HoverMenuItem
          key={index}
          icon={item.icon}
          label={item.label}
          onClick={() => handleMenuItemClick(item.path)}
        />
      ))}
    </Menu>
  );
}

function HoverMenuItem({ icon, label, onClick }) {
  const [hover, setHover] = useState(false);

  return (
    <MenuItem
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      sx={{
        borderRadius: "10px",
        my: "3px",
        px: "10px",
        height: "48px",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: hover ? "#fef1f4 !important" : "transparent",
        transition: "0.2s ease",
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <Iconify icon={icon} width={28} />
        <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>
          {label}
        </Typography>
      </Box>

      {/* Sliding arrow on hover */}
      <Box
        sx={{
          opacity: hover ? 1 : 0,
          transform: hover ? "translateX(0px)" : "translateX(-8px)",
          transition: "0.25s ease",
        }}
      >
        <Iconify icon="material-symbols:arrow-forward" width={20} />
      </Box>
    </MenuItem>
  );
}
